// contexto para almacenar las imagenes de manera globar

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { partNumberService, type PartNumber } from '../services/partnumber.service'
import Bounce from 'react-activity/dist/Bounce'
import { ProductContext } from './ProductContext'

// Define the shape of the context value
interface PartNumberContextValue {
  partNumber: PartNumber | undefined
  setPartNumber: React.Dispatch<React.SetStateAction<PartNumber | undefined>>
  renderPartNumber: () => React.ReactElement
}
// Create the context
export const PartNumberContext = createContext<PartNumberContextValue>({
  partNumber: undefined,
  setPartNumber: () => {},
  renderPartNumber: () => <></>

})

// Create a provider component
export const PartNumberProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [partNumber, setPartNumber] = useState<PartNumber | undefined>(undefined)
  const [fetching, setFetching] = useState<boolean>(true)
  const { product } = useContext(ProductContext)

  const fetchPartNumber = useCallback(async () => {
    setFetching(true)
    const fetchPartNumber = await partNumberService.getPartNumber(product?.partnumber ?? undefined)
    if (fetchPartNumber?.partnumber === undefined) {
      setPartNumber(undefined)
      return
    }
    const decodedPartNumber = fetchPartNumber.partnumber
      .replace('%2528', '(')
      .replace('%2529', ')')

    fetchPartNumber.partnumber = decodedPartNumber
    setPartNumber(fetchPartNumber)
  }, [product])

  useEffect(() => {
    fetchPartNumber().then(() => setFetching(false)).catch((error) => console.error(error))
  }, [fetchPartNumber])

  const renderPartNumber = (): React.ReactElement => {
    const isPartNumberMatching =
      product?.partnumber !== null &&
      partNumber?.partnumber !== undefined &&
      product?.partnumber === partNumber.partnumber

    if (fetching) {
      return (
        <Bounce
          className='name'
          color='#4285f4'
          size={30}
        />
      )
    }

    return (
      <h4 className='name'>
        {isPartNumberMatching ? `P/N : ${partNumber?.partnumber}` : 'P/N not provided'}
      </h4>
    )
  }

  return (
    <PartNumberContext.Provider value={{ partNumber, setPartNumber, renderPartNumber }}>
      {children}
    </PartNumberContext.Provider>
  )
}
